// components
import { FeatureDiscoveryStore } from '@sdb/planning-ui';

// constants
import { FD_SDB_TEMPLATE_TOUR_ID } from './FeatureDiscoveryGate.consts';

// hooks
import { useState } from 'react';

// utils
import { t } from 'i18next';
import { FeatureDiscoveryWithProviders } from './FeatureDiscoveryWithProviders';

export const FeatureDiscoveryGate = (props) => {
  const [featureDiscoverStore] = useState(
    new FeatureDiscoveryStore(FD_SDB_TEMPLATE_TOUR_ID)
  );

  // Note: we set the state to viewed to suppress auto play
  // the tour will only be shown through the navigation's menu item
  const isViewed = localStorage.getItem(FD_SDB_TEMPLATE_TOUR_ID);
  !isViewed && featureDiscoverStore?.setViewed();

  return (
    <FeatureDiscoveryWithProviders
      {...props.environmentProps}
      {...props}
      previous={t('featureDiscovery.previous')}
      next={t('featureDiscovery.next')}
      done={t('featureDiscovery.done')}
      of={t('featureDiscovery.of')}
      tourVersion="1"
    />
  );
};
